import { AppLayoutComponent } from '../theme/app-layout/app-layout.component';
import { LandingComponent } from './reporting/components/landing/landing.component';
import { ReportComponent } from './reporting/components/report/report.component';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { MenuService, RoleGuard } from '@core';
import { Role } from '@core/authentication/auth.roles';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {
        path: '',
        component: LandingComponent,
      },
      {
        path: 'info',
        canActivateChild: [MsalGuard],
        loadChildren: () => import('./info/info.module').then(m => m.InfoModule),
      },
      {
        path: 'kpi/maintenance',
        canActivate: [MsalGuard, RoleGuard],
        data: { roles: [Role.Planning] },
        loadChildren: () =>
          import('./plan-data-maintenance/plan-data-maintenance.module').then(
            m => m.PlanDataMaintenanceModule
          ),
      },
    ],
  },
  {
    path: 'sessions',
    loadChildren: () => import('./sessions/sessions.module').then(m => m.SessionsModule),
    data: { title: 'Sessions', titleI18n: 'sessions' },
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: false,
    }),
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (router: Router, menuService: MenuService) => {
        return () =>
          menuService.getAll().subscribe(menu => {
            const cloneMenu = structuredClone(menu);
            menuService.recursMenuForRouting(cloneMenu, null);
            cloneMenu
              .flatMap(x => x.children)
              .concat(cloneMenu)
              .forEach(child => {
                if (child?.report) {
                  routes[0].children?.push({
                    path: child.route,
                    component: ReportComponent,
                    canActivate: [MsalGuard, RoleGuard],
                    data: {
                      report: child.report,
                      roles: child.roles,
                    },
                  });
                }
              });
            router.resetConfig([...routes]);
          });
      },
      multi: true,
      deps: [Router, MenuService],
    },
  ],
})
export class RoutesRoutingModule {}
